// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {"355": "code_activation-CodeActivationModal","58": "code_activation-PhoneVerification",}[chunkId] + "." + {"355": "77e1d4552b20cc2c","58": "bb8702a88214b207",}[chunkId] + ".js"
}